// Database client for shared readers. In the browser this is the signed-in
// client. Inside a page-summary server function it is that request's
// authenticated client (row-level security still applies as the user), so the
// same card logic runs on the server and only the result reaches the browser.
import { supabase } from "@/integrations/supabase/client";

type Store = { getStore(): any; run<T>(s: any, fn: () => T): T };
const KEY = "__monroyaDbStore";

export function db(): typeof supabase {
  const als = (globalThis as any)[KEY] as Store | undefined;
  return (als?.getStore() as typeof supabase | undefined) ?? supabase;
}

/** True while running inside a server page summary. */
export function onServerSummary(): boolean {
  const als = (globalThis as any)[KEY] as Store | undefined;
  return !!als?.getStore();
}
